export const GIFT_CODE_PATTERN = /^TGC-[A-HJ-NP-Z2-9]{4}-[A-HJ-NP-Z2-9]{4}$/;
export const GIFT_CODE_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

export function buildGiftCode(randomIndex) {
  let body = "";
  for (let index = 0; index < 8; index += 1) {
    body += GIFT_CODE_ALPHABET[randomIndex(GIFT_CODE_ALPHABET.length)];
  }
  return `TGC-${body.slice(0, 4)}-${body.slice(4)}`;
}

export function normalizeGiftCode(value = "") {
  const compact = String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .replace(/^TGC/, "");

  const body = compact.slice(0, 8);
  const first = body.slice(0, 4);
  const second = body.slice(4, 8);
  return ["TGC", first, second].filter(Boolean).join("-");
}

export function isValidGiftCode(value) {
  return GIFT_CODE_PATTERN.test(normalizeGiftCode(value));
}

export function isValidCheckoutEmail(value = "") {
  const normalized = String(value).trim();
  return (
    normalized.length >= 3 &&
    normalized.length <= 320 &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)
  );
}

export function getPurchaseDestination(purchase) {
  if (!purchase) return "recovery";
  if (purchase.status === "paid") return "continuation";
  if (purchase.status === "gift_created" && purchase.recipientLink) return "delivery";
  if (["refund_blocked", "refunded", "expired"].includes(purchase.status)) {
    return "unavailable";
  }
  return "recovery";
}

export function getDraftStorageKey(giftCode) {
  return isValidGiftCode(giftCode)
    ? `tgc_purchase_draft_${normalizeGiftCode(giftCode)}`
    : null;
}

export function readStoredPurchase(storage) {
  if (!storage) return null;

  try {
    const parsed = JSON.parse(storage.getItem("tgc_active_purchase") || "null");
    if (
      !parsed ||
      !isValidGiftCode(parsed.giftCode) ||
      typeof parsed.accessToken !== "string" ||
      parsed.accessToken.length < 32
    ) {
      return null;
    }
    return {
      giftCode: normalizeGiftCode(parsed.giftCode),
      accessToken: parsed.accessToken,
    };
  } catch {
    return null;
  }
}

export function writeStoredPurchase(storage, purchase) {
  if (!storage || !purchase?.giftCode || !purchase?.accessToken) return;
  storage.setItem(
    "tgc_active_purchase",
    JSON.stringify({
      giftCode: normalizeGiftCode(purchase.giftCode),
      accessToken: purchase.accessToken,
    })
  );
}

export function clearStoredPurchase(storage) {
  storage?.removeItem("tgc_active_purchase");
}
